module.exports = __webpack_public_path__ + "img/u140.0f44c263.jpg";